import { Skeleton } from "@mui/material";
import Box from "@mui/material/Box";
import { SchedulesSkeleton } from "../AgendaSkeleton";
import { useLocationData } from "../../../providers/geolocation";

export const ProfessionalCardSkeleton = () => {

  const { mapBig } = useLocationData();

  return (
    <Box className="card">
      <Box className="row g-0">
        <Box className={`col-12 ${!mapBig && 'col-md-6 col-xl-8'} px-4 py-4`}>
          <Box className="row align-items-center g-0">
            <Box className="col-4 col-sm-3 col-xl-2 pb-4">
              <Box
                sx={{
                  backgroundColor: "lightgray",
                }}
                className="img-wrap"
              ></Box>
            </Box>
            <Box className="col-12 col-sm ps-sm-3 pb-4">
              <Skeleton variant="text" className="text-primary mb-1 small" />
              <Skeleton variant="text" className="mb-1" />
              <Skeleton variant="text" className="mb-1 overflow-wrap" />
              <Skeleton variant="text" />
            </Box>
          </Box>
          <Box className="row">
            <Box className="col-12 col-sm-6 pb-3">
              <Skeleton variant="text" className="mb-1 text-muted" />
              <Box className="text-format text-12 text-muted details-height">
                <Box>
                  <Skeleton variant="text" className="py-1" />
                  <Skeleton variant="text" className="py-1" />
                  <Skeleton variant="text" className="py-1" />
                  <Skeleton variant="text" className="py-1" />
                </Box>
              </Box>
            </Box>
            <Box className="col-12 col-sm-6 pb-3">
              <Skeleton variant="text" className="mb-1 text-muted" />
              <Box className="text-format text-12 text-muted details-height">
                <Box>
                  <Skeleton variant="text" className="py-1" />
                  <Skeleton variant="text" className="py-1" />
                  <Skeleton variant="text" className="py-1" />
                  <Skeleton variant="text" className="py-1" />
                </Box>
              </Box>
            </Box>
          </Box>
          <Skeleton variant="text" className="mt-3 text-center" />
        </Box>
        <Box className={`col-12 ${!mapBig && 'col-md-6 col-xl-4'} bg-light hover border-md-left border-top border-md-top-0 px-4 py-4`}>
          <Box className="d-grid mb-4">
            <Box className="text-start rounded-4 bg-white text-wrap px-3 py-2">
              <Box className="row g-0 align-items-center flex-nowrap w-100">
                <Box className="col">
                  <Skeleton variant="text" className="mb-1" />
                  <Skeleton variant="text" className="opacity-50 small mb-0" />
                </Box>
              </Box>
            </Box>
          </Box>
          <Box className="agenda">
            <SchedulesSkeleton />
          </Box>
          <Skeleton variant="text" className="mt-3 text-center" />
        </Box>
      </Box>
    </Box>
  );
};
